<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="mb-lg">
            <div class="card" v-if="!isLoading">
              <argon-alert v-if="showAlert" color="danger">
                <strong>Alerta!</strong> Es necesario seleccionar una o varias
                imagenes!
              </argon-alert>
              <argon-alert
                v-if="showSuccess"
                color="success"
                :dismissible="true"
              >
                <strong>Completado!</strong> Campos guardados correctamente!
              </argon-alert>
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0">Galeria</h4>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-sm">META</p>
                <hr class="horizontal dark" />
                <div class="row">
                  <div v-if="imagesLocal !== undefined" class="container-fluid">
                    <div class="row">
                      <div
                        v-for="imageLocal in imagesLocal"
                        class="col-lg-3 col-md-3 col-12 mb-4"
                        :key="imageLocal"
                      >
                        <img :src="imageLocal" class="img-fluid rounded" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Imagen(es)</label
                    >
                    <argon-input
                      type="file"
                      id="2"
                      name="Imagen(es)"
                      @change-image="onFileImageChange($event)"
                      accept="image/*"
                      multiple="multiple"
                    />
                  </div>
                  <div v-if="videosLocal !== undefined" class="container-fluid">
                    <div class="row">
                      <div
                        v-for="videoLocal in videosLocal"
                        class="col-lg-3 col-md-3 col-12 mb-4"
                        :key="videoLocal"
                      >
                        <video class="img-fluid rounded" autoplay loop>
                          <source :src="videoLocal" type="video/mp4" />
                          <source src="movie.ogg" type="video/ogg" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Video(s)</label
                    >
                    <argon-input
                      type="file"
                      id="3"
                      name="Video(s)"
                      @change-image="onFileVideoChange($event)"
                      accept="video/*"
                      multiple="multiple"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Titulo</label
                    >
                    <argon-input v-model="gallery.title" id="0" name="Titulo" />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Descripción</label
                    >
                    <argon-textarea
                      v-model="gallery.description"
                      id="1"
                      name="Descripción"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <argon-button
                      color="primary"
                      size="lg"
                      class="ms-auto"
                      @click-callback="finalValidation"
                      :fullWidth="true"
                      >Guardar</argon-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "gallery-card",
  props: {
    galleryID: { type: String, required: true },
  },
  data() {
    return {
      isLoading: true,
      showAlert: false,
      showSuccess: false,
      valid: Array(4).fill(true),
      galleryIDLocal: this.galleryID,
      imagesLocal: undefined,
      imagesLocalSave: undefined,
      videosLocal: undefined,
      videosLocalSave: undefined,
      gallery: {
        title: "",
        description: "",
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonAlert, ArgonTextarea },
  created() {
    // console.log("GALLERY GALLERY GALLERY");
    // console.log(this.galleryIDLocal);
    if (this.galleryIDLocal !== "0") {
      this.plain
        .get(`/galleries/${this.galleryIDLocal}`)
        .then((response) => {
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.imagesLocal = response.data.images_url;
          this.imagesLocalSave = response.data.images_url;
          this.videosLocal = response.data.videos_url;
          this.videosLocalSave = response.data.videos_url;
          delete response.data.images_url;
          delete response.data.videos_url;
          this.gallery = response.data;
          this.isLoading = false;
          // console.log("RESPONSE GALLERY");
          // console.log(this.gallery);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    } else {
      this.galleryIDLocal = undefined;
      this.isLoading = false;
    }
  },
  methods: {
    absoluteValidation(event) {
      this.showAlert = false;
      this.showSuccess = false;
      this.valid[event.inputIndex] = event.valid;
    },
    finalValidation() {
      if (this.valid.includes(false)) {
        this.showAlert = true;
        window.scrollTo(0, 0);
      } else {
        if (this.galleryIDLocal !== undefined) this.editGallery();
        else {
          // console.log(this.imagesLocal);
          if (this.imagesLocal !== undefined) this.createGallery();
          else {
            this.showAlert = true;
            window.scrollTo(0, 0);
          }
        }
      }
    },
    createGallery() {
      // console.log("CREANDO GALLERY");
      // console.log(this.gallery);
      let formData = new FormData();

      Object.entries(this.gallery).forEach(([key, value]) => {
        switch (key) {
          case "videos":
            this.gallery.videos.forEach((video) => {
              formData.append(`gallery[${key}][]`, video);
            });
            break;
          case "images":
            this.gallery.images.forEach((image) => {
              formData.append(`gallery[${key}][]`, image);
            });
            break;
          default:
            formData.append(`gallery[${key}]`, value);
            break;
        }
      });

      this.form
        .post("/galleries", formData)
        .then((response) => {
          // console.log("GALLERY creado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          this.galleryIDLocal = response.data.id; //SOLUCIONAR PROBLEMA DE ALERTAS AQUI ES CON LA NAVEGACION route y con una variable local
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.imagesLocal = response.data.images_url;
          this.imagesLocalSave = response.data.images_url;
          this.videosLocal = response.data.videos_url;
          this.videosLocalSave = response.data.videos_url;
          delete response.data.images_url;
          delete response.data.videos_url;
          this.gallery = response.data;
          // console.log("CREATE");
          // console.log(this.gallery);
        })
        .catch((error) => {
          console.log("Error al crear galleries", error);
        });
    },
    editGallery() {
      // console.log("PREPARANDO PARA EDITAR");
      // console.log(this.gallery);
      let formData = new FormData();
      
      Object.entries(this.gallery).forEach(([key, value]) => {
        switch (key) {
          case "videos":
            this.gallery.videos.forEach((video) => {
              formData.append(`gallery[${key}][]`, video);
            });
            break;
          case "images":
            this.gallery.images.forEach((image) => {
              formData.append(`gallery[${key}][]`, image);
            });
            break;
          default:
            formData.append(`gallery[${key}]`, value);
            break;
        }
      });

      this.form
        .patch(`/galleries/${this.galleryIDLocal}`, formData)
        .then((response) => {
          // console.log("GALLERY editado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.imagesLocal = response.data.images_url;
          this.imagesLocalSave = response.data.images_url;
          this.videosLocal = response.data.videos_url;
          this.videosLocalSave = response.data.videos_url;
          delete response.data.images_url;
          delete response.data.videos_url;
          this.gallery = response.data;
          // console.log("EDIT");
          // console.log(this.gallery);
        })
        .catch((error) => {
          console.log("Error al editar galleries", error);
        });
    },
    onFileImageChange(files) {
      // console.log("IMAGES FILES");
      // console.log(files.length);
      if (files.length !== 0) {
        this.imagesLocal = Array.from(files, (fileImg) =>
          URL.createObjectURL(fileImg)
        );
        this.gallery.images = Array.from(files);
        this.showAlert = false;
        // console.log("ON FILE IMAGE CHANGE");
        // console.log(this.gallery);
      } else {
        if (Object.keys(this.gallery).includes("images"))
          delete this.gallery.images;

        this.imagesLocal = this.imagesLocalSave;
      }
    },
    onFileVideoChange(files) {
      // console.log("VIDEOS FILES");
      // console.log(files.length);
      if (files.length !== 0) {
        this.videosLocal = Array.from(files, (fileVid) =>
          URL.createObjectURL(fileVid)
        );
        this.gallery.videos = Array.from(files);
        this.showAlert = false;
        // console.log("ON FILE VIDEO CHANGE");
        // console.log(this.gallery);
      } else {
        if (Object.keys(this.gallery).includes("videos"))
          delete this.gallery.videos;

        this.videosLocal = this.videosLocalSave;
      }
    },
  },
};
</script>
